export enum RateType {
  FIXED = 'Fixed',
  PERCENTAGE = 'Percentage',
}
